/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as React from "react";
import { connect } from "react-redux";
import { Redirect, RouteComponentProps, withRouter } from "react-router";
import { SignInPath } from "../../paths/pathIndex";
import { IAppState } from "../appState";

interface IOwnProps {
    children: (userInfo: UserInfo) => JSX.Element;
}

interface IStateProps {
    userInfo: UserInfo | false | undefined;
}

type IProps = IOwnProps & IStateProps;

class UnconnectedRequireSignedInOrRedirect extends React.PureComponent<IProps & RouteComponentProps<any>, {}> {
    public render() {
        const { children, location, userInfo } = this.props;

        if (userInfo == null) {
            return "// TODO: LOADING";
        }

        if (userInfo === false) {
            const to = SignInPath.of({ from: `${location.pathname}${location.search}` });
            return <Redirect to={to} />;
        }

        return children(userInfo);
    }
}

function mapStateToProps(state: IAppState): IStateProps {
    const { user } = state;
    const { userInfo } = user;
    return { userInfo };
}

export const RequireSignedInOrRedirect = withRouter(connect<IStateProps, {}, IOwnProps, IAppState>(mapStateToProps)(UnconnectedRequireSignedInOrRedirect));
